import {useReportingResource} from '@/hooks/useReportingResource';
import {downloadFile} from '@/lib/api';
import NativeWordHistory from './NativeWordHistory';
import CompletionAssessmentForm from './CompletionAssessmentForm';
export const ASSESSMENT_FIELDS=[
 ['opinion_rationale','Dasar pilihan opini yang dicatat'],
 ['misstatement_scope_analysis','Salah saji dan dampak pervasif'],
 ['evidence_limitation_analysis','Keterbatasan bukti dan dampaknya'],
 ['modification_basis','Dasar modifikasi atau alasan tidak diperlukan'],
 ['emphasis_evaluation','Pertimbangan penekanan suatu hal'],
 ['other_matter_evaluation','Pertimbangan hal lain'],
 ['going_concern_evaluation','Pelaporan kelangsungan usaha'],
 ['kam_evaluation','KAM dan relevansinya'],
 ['comparative_evaluation','Implikasi pelaporan komparatif'],
 ['conclusion','Kesimpulan auditor atas pertimbangan pelaporan'],
];
export default function ReportingJudgmentAssessment({id}){
 const resource=useReportingResource(id,'reporting-judgment-assessment'),evidence=useReportingResource(id,'evidence');
 if(resource.error)return <p role="alert">{resource.error}</p>;
 if(!resource.data)return <p>Memuat pertimbangan pelaporan…</p>;
 const data=resource.data;
 return <section className="space-y-3">
 <div className="bg-white border rounded-sm p-3" data-testid="reporting-judgment-decision"><h3 className="font-semibold text-sm">Keputusan opini yang dicatat</h3>
 <p className="text-sm my-2">{data.canonical_decision?.opinion||'Belum dicatat'} · {data.canonical_decision?.approved_current?'Persetujuan Partner mutakhir':'Persetujuan Partner belum mutakhir'}</p>
 <p className="text-xs">Dokumentasikan dasar profesional atas keputusan aktual dan hasil evaluasi C180/C190. Opini tidak dipilih otomatis dari jumlah salah saji atau status dokumen.</p></div>
 {evidence.error&&<p role="alert">{evidence.error}</p>}
 <CompletionAssessmentForm key={`${id}:${data.mutation_version||0}`} id={id} data={data} fields={ASSESSMENT_FIELDS} title="D130 — Pertimbangan Pelaporan"
 endpoint={`/engagements/${id}/reporting-judgment-assessment`} prefix="reporting-judgment-assessment" testId="reporting-judgment-assessment-assessment" evidence={evidence.data||[]} reloadEvidence={evidence.reload} reloadAssessment={resource.reload} mutate={resource.mutate} busy={resource.busy}
/>
 <button type="button" className="border rounded p-2 text-xs" disabled={!data.id} onClick={()=>downloadFile(`/engagements/${id}/reporting-judgment-assessment/export/docx`,'D130-working-copy.docx')}>Ekspor Word D130</button>
 <NativeWordHistory id={id} exportType="D130" recordId={data.id}/>
 </section>;
}
